import { isNewsWriterRole, type NewsAuthor } from '@crm/shared'

/** Публиковать — ADMIN и руководители подразделений (список в @crm/shared). */
export function canWriteNews(role: string | undefined | null): boolean {
  return isNewsWriterRole(role)
}

export function canEditNews(
  role: string | undefined | null,
  authorId: string | null,
  userId: string | undefined | null,
): boolean {
  if (!role) return false
  if (role === 'ADMIN') return true
  if (!canWriteNews(role)) return false
  return Boolean(authorId && userId && authorId === userId)
}

export function formatNewsDate(value: string): string {
  return new Date(value).toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function authorName(author: NewsAuthor | null): string {
  if (!author) return 'удалённый автор'
  return author.name?.trim() || author.email
}
